import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-call-to-action',
    templateUrl: './call-to-action.component.html',
    styleUrls: ['./call-to-action.component.scss'],
    imports: [RouterLink]
})
export class CallToActionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
